import React from 'react';
import {
  ChakraProvider,
  Box,
  theme,
} from '@chakra-ui/react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Gallery from './components/Gallery';
import ForbiddenKnowledgeQuiz from './components/ForbiddenKnowledgeQuiz'; // Updated import
import Story from './components/Story';
import NotFound from './components/NotFound';
import ThreeDVisuals from './components/ThreeDVisuals';
import Puzzle from './components/Puzzle';
import MadnessMeter from './components/MadnessMeter';
import IndexPage from './components/IndexPage'; // New import for IndexPage

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Router>
        <Box textAlign="center" fontSize="xl">
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/quiz" element={<ForbiddenKnowledgeQuiz />} /> {/* Updated component reference */}
            <Route path="/story" element={<Story />} />
            <Route path="/3d" element={<ThreeDVisuals />} />
            <Route path="/puzzle" element={<Puzzle />} />
            <Route path="/madness" element={<MadnessMeter />} />
            <Route path="/index" element={<IndexPage />} /> {/* New route for IndexPage */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Box>
      </Router>
    </ChakraProvider>
  );
}

export default App;
